<template>
    <main class="dashboard">
        <div class="main-section" style="min-height: 100vh; background: rgb(248, 249, 253);">
            <div class="container">
                <div class="has-background-white tipo_negocio pt-3">
                    <div class="p-1">
                        <p class="title_type">
                            Tipo de negocio
                        </p>
                        <table class="central_table non_selectable">
                            <tr v-for="row in super_types" :key="row" class="super_type">
                                <td>
                                    <span class="super_style">{{ row }}</span>
                                    <table class="sub_table">
                                        <tr v-for="subrow in basic_data.all_business_types[row]" :key="subrow.name"
                                            class="type">
                                            <td>
                                                <input type="checkbox" class="big_checkbox"
                                                    :id="'bt_' + subrow.super_type + '_n_' + subrow.name"
                                                    v-model="checked[subrow.super_type + '_' + subrow.name]" />
                                            </td>
                                            <td>
                                                <div class="type_name"
                                                    @click="toggle(subrow.super_type + '_' + subrow.name)">
                                                    {{ subrow.name }}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <p class="title_type second_section non_selectable">
                        ¿Esta empresa debe clasificar las ventas?
                        <input class="big_checkbox" type="checkbox" v-model="classify_by_sales" />
                        <span class="classify_value" @click="toggle_classify()">
                            {{ classify_by_sales ? 'Si' : 'No' }} &nbsp; &nbsp; &nbsp;
                        </span>
                    </p>
                    <div class="button_div">
                        <b-button class="grabar" type="is-secondary" @click="grabarTiposNegocio()">
                            Grabar
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { saveTipoNegocio } from "@/api/carteraAnalista";
import { consoleHandlerError, notificate } from "@/utils/message";

export default {
    name: "CompanyInfoBusinessType",
    props: {
        basicData: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    components: {
    },
    created() {
    },
    mounted() {
    },
    data() {
        return {
            basic_data: {},
            super_types: [],
            checked: {},
            classify_by_sales: false,
        };
    },
    computed: {
    },
    methods: {
        async grabarTiposNegocio() {
            console.log('checked: ', JSON.stringify(this.checked), this.basic_data.companyId);
            const response = saveTipoNegocio(this.basic_data.companyId, this.checked, this.classify_by_sales);
            console.log('response:', response);
            try {
                const resp = await response;
                notificate(resp.data['status']);
                if (resp['status'] == 200) {
                    this.basicData.classify_by_sales = this.classify_by_sales;
                }
            } catch (error) {
                consoleHandlerError({ error, empty: true });
            }
        },
        toggle_classify() {
            this.classify_by_sales = !this.classify_by_sales;
        },
        toggle(key) {
            const newChecked = { ...this.checked };
            console.log('toggle:', key);
            newChecked[key] = !newChecked[key];
            this.checked = newChecked;
        }
    },
    watch: {
        basicData: {
            handler(data) {
                this.basic_data = data;
                console.log('business types1:', this.basic_data.all_business_types);
                console.log('business types2:', this.basic_data.business_types);
                console.log('classify by sales?:', this.basic_data.classify_by_sales);
                this.classify_by_sales = this.basic_data.classify_by_sales;
                this.super_types = [];
                for (const [superType, names] of Object.entries(this.basic_data.all_business_types)) {
                    this.super_types.push(superType)
                    for (const elem of names) {
                        this.checked[elem.super_type + '_' + elem.name] = false;
                    }
                }
                for (const names of Object.values(this.basic_data.business_types)) {
                    for (const elem of names) {
                        this.checked[elem.super_type + '_' + elem.name] = true;
                    }
                }
                console.log('checked name:', JSON.stringify(this.checked));
            },
            immediate: true,
        },
    }
};
</script>
<style scoped>
.classify_value {
    display: inline-block;
    min-width: 100px;
    text-align: left;
    padding: 5px 10px;
    cursor: pointer;
    border: 1px solid transparent;
    font-family: monospace, monospace;
}

.non_selectable {
    user-select: none;
}

.big_checkbox {
    transform: scale(1.5);
    margin: 10px;
}

.second_section {
    position: relative;
    left: -100px;
    padding-top: 30px;
    padding-bottom: 10px;
}

.container {
    width: 100%;
}

.super_style {
    font-weight: bold;
    font-size: 110%;
}

.super_type {
    text-align: left;
    margin-left: 10%;
}

.type {
    text-align: left;
    margin-left: 40%;
}

.config_container {
    width: 400px;
    margin-left: 100px;
}

.full-width-div {
    width: 100%;
    margin: 0;
    padding: 0;
}

.central_table {
    margin-left: 36%;
}

.sub_table {
    margin-left: 20%;
}

.title_type {
    font-weight: bold;
    font-size: 1.2em;
    margin-left: 34%;
    margin-bottom: 2%;
}

.button_div {
    text-align: right;
    margin-top: 0;
    margin-right: 30%;
    padding-bottom: 60px;
}

.type_name {
    margin-left: 0.5em;
    margin-top: 0.15em;
    font-size: 110%;
}
</style>